export type SentryEnvironment = 'CI' | 'BETA' | 'MP'

export interface SentryBuildConfig {
  environment?: string
  dsns: Record<SentryEnvironment, string>
  release: string
  debug: boolean
}

/** Only this public configuration is embedded in the browser bundle. */
export function createSentryBuildConfig(
  env: Record<string, string | undefined>,
  version: string
): SentryBuildConfig {
  return {
    environment: env.ANKERDOCK_ENVIRONMENT || undefined,
    dsns: {
      CI: env.ANKER_SENTRY_DSN_CI || '',
      BETA: env.ANKER_SENTRY_DSN_BETA || '',
      MP: env.ANKER_SENTRY_DSN_MP || '',
    },
    release: `AnkerDockManager-web@${version}`,
    debug: env.ANKER_SENTRY_DEBUG === 'true',
  }
}

export function resolveSentryEnvironment(
  hostname: string,
  development: boolean,
  explicit?: string
): SentryEnvironment | undefined {
  if (explicit) {
    return ['CI', 'BETA', 'MP'].includes(explicit) ? (explicit as SentryEnvironment) : undefined
  }
  if (development) return 'CI'
  if (hostname.includes('-beta')) return 'BETA'
  if (['ankerdockmanager-pre.anker.com', 'ankerdockmanager.anker.com'].includes(hostname)) {
    return 'MP'
  }
  return 'CI'
}

export function resolveSentryConfig(
  config: SentryBuildConfig,
  hostname: string,
  development: boolean
) {
  const environment = resolveSentryEnvironment(hostname, development, config.environment)
  if (!environment) return undefined
  const dsn = config.dsns[environment].trim()
  if (!dsn) return undefined
  try {
    const url = new URL(dsn)
    if (url.protocol !== 'https:' || !url.username || !url.hostname || url.pathname === '/') {
      return undefined
    }
  } catch {
    return undefined
  }
  return { environment, dsn, release: config.release, debug: config.debug }
}
